import apiClient from '@app/config/axios.config'
import { downloadFile } from './downloadFile'
import { toast } from '@app/components/ui/Toast/toast'
import * as Sentry from '@sentry/react'

export const pollForReport = (report_id: string, downloadFilename: string) => {
  const pollingStart = Date.now()
  let apiErrorCount = 0
  const MAX_API_ERRORS = 5

  const scheduleNextPoll = () => {
    setTimeout(poll, 3000)
  }

  const poll = async () => {
    try {
      const reportStatusResponse = await apiClient.get(`/report/status/${report_id}`)

      const { status, download_url }: { status: string; download_url: string | null } =
        reportStatusResponse.data

      const timeoutTest = Date.now() - pollingStart
      const timedOut = timeoutTest > 15 * 60 * 1000 // 15 minutes

      if (timedOut) {
        Sentry.captureException(new Error('Report request timed out', { cause: report_id }))
      }

      if (status == 'ERROR' || timedOut) {
        toast({
          description:
            'There was an error generating the report. Please notify your Urban Intelligence contact or submit feedback.',
          type: 'error',
        })
        return
      }

      if (status == 'COMPLETED' && download_url) {
        toast({
          description: 'Report has been generated. Downloading...',
          type: 'info',
        })

        downloadFile(download_url, downloadFilename)
        return
      }

      scheduleNextPoll()
    } catch (error) {
      apiErrorCount++

      if (apiErrorCount >= MAX_API_ERRORS) {
        Sentry.captureException(
          new Error(`Report ${report_id} status polling failed ${MAX_API_ERRORS} times`, {
            cause: error,
          }),
        )

        toast({
          description:
            'There was an error generating the report. Please notify your Urban Intelligence contact or submit feedback.',
          type: 'error',
        })
        return
      }

      scheduleNextPoll()
    }
  }

  poll()
}
